import { render, staticRenderFns } from "./DashTopBar.vue?vue&type=template&id=24423976&scoped=true&"
import script from "./DashTopBar.vue?vue&type=script&lang=js&"
export * from "./DashTopBar.vue?vue&type=script&lang=js&"
import style0 from "./DashTopBar.vue?vue&type=style&index=0&id=24423976&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24423976",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/home/runner/_work/studio/studio/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAppBar } from 'vuetify/lib'
import { VChip } from 'vuetify/lib'
import { VSelect } from 'vuetify/lib'
import { VSpacer } from 'vuetify/lib'
installComponents(component, {VAppBar,VChip,VSelect,VSpacer})
